import type { ReceiptTemplate } from '../schema';

export const cartierTemplate: ReceiptTemplate = {
  id: 'cartier',
  name: 'Cartier Receipt',
  brand: 'CARTIER',
  description: 'Luxury jewelry and watches receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'cartier-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/cartier.png',
        logoData: '',
        logoWidth: 120,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'CARTIER BOUTIQUE',
          '1200 Dark Avenue',
          'Monsterville, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'cartier-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'cartier-date', label: 'Date:', value: '01/04/2026' },
          { id: 'cartier-trans', label: 'Trans:', value: '749182' },
        ],
        column2: [
          { id: 'cartier-time', label: 'Time:', value: '13:18:45' },
          { id: 'cartier-assoc', label: 'Advisor:', value: 'MIKE W.' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'cartier-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'cartier-item-1', name: 'Love Bracelet Yellow Gold', quantity: '1', price: '7550.00'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'cartier-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'cartier-subtotal', label: 'Subtotal', value: '7,550.00', isBold: false, isLarge: false },
          { id: 'cartier-tax', label: 'Tax (8.875%)', value: '670.06', isBold: false, isLarge: false },
          { id: 'cartier-total', label: 'TOTAL', value: '8,220.06', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'cartier-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'cartier-card', label: 'AMEX', value: '***********4144' },
          { id: 'cartier-auth', label: 'Auth', value: '592847' },
          { id: 'cartier-status', label: 'Status', value: 'APPROVED' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'cartier-warranty',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '── WARRANTY INFORMATION ──\nThis item includes a 2-year\ninternational warranty.',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: false,
      },
    },
    {
      id: 'cartier-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: 'CT749182012726',
        showValue: true,
        width: 1.5,
        height: 45,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'cartier-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Thank you for choosing Cartier.',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

